const detectDevice = {
    isPhone: () => {
        if (
            /Android|webOS|iPhone|iPod|iPad|BlackBerry|IEMobile|Opera Mini/i.test(
                navigator.userAgent
            )
        ) {
            return true;
        }
        return false;
    },

    isTablet: () => {
        if (
            /iPad|ipad/i.test(navigator.userAgent) ||
            document.documentElement.classList.contains('ipad')
        ) {
            return true;
        }
        return false;
    },

    isIpadOS: () => {
        if (
            navigator.maxTouchPoints &&
            navigator.maxTouchPoints > 2 &&
            /MacIntel/.test(navigator.platform)
        ) {
            return true;
        }

        return false;
    },
};

export default detectDevice;
